import { getBoundingClientRect } from './coordinates';

export const isInViewport = function (elem: HTMLElement | SVGPathElement, sideBarWidth: number) {
  const bounding = getBoundingClientRect(elem);
  const elementHeight = bounding.height;
  const elementWidth = bounding.width;
  return (
    bounding.top >= -elementHeight &&
    bounding.left - sideBarWidth >= -elementWidth &&
    bounding.right <=
      (window.Widget.width || document.documentElement.clientWidth) + elementWidth &&
    bounding.bottom <=
      (window.Widget.height || document.documentElement.clientHeight) + elementHeight
  );
};

export const isWholeInViewport = (elem: HTMLElement | SVGPathElement, sideBarWidth: number) => {
  const bcr = getBoundingClientRect(elem);

  return (
    bcr.top >= 0 &&
    bcr.left - -sideBarWidth >= 0 &&
    bcr.right <= (window.Widget.width || document.documentElement.clientWidth) &&
    bcr.bottom <= (window.Widget.height || document.documentElement.clientHeight)
  );
};

export const getElemsExtremeCoords = (elems: Array<SVGPathElement | SVGAElement>) =>
  elems.reduce(
    (acc, pathEl) => {
      const { left, right, top, bottom } = getBoundingClientRect(pathEl);

      acc.minY = Math.min(acc.minY, top);
      acc.maxX = Math.max(acc.maxX, right);
      acc.maxY = Math.max(acc.maxY, bottom);
      acc.minX = Math.min(acc.minX, left);

      return acc;
    },
    {
      minY: Infinity,
      maxX: -Infinity,
      maxY: -Infinity,
      minX: Infinity,
    },
  );

export const getCenterCoords = (extremeCoords: {
  minY: number;
  maxX: number;
  maxY: number;
  minX: number;
}): { x: number; y: number } => {
  const { maxX, minX, maxY, minY } = extremeCoords;

  return {
    x: (maxX + minX) / 2,
    y: (maxY + minY) / 2,
  };
};
